import React from 'react';
import { InvestmentAnswer, InvestmentQuestion } from './utils';

export const allocationQuestionText: {
  [questionId: number]:
    | {
        questionText: JSX.Element;
        options: {
          [id: number]: JSX.Element | undefined;
        };
      }
    | undefined;
} = {
  20008: {
    questionText: <>What is the purpose of this contribution to the program?</>,
    options: {
      0: <>To support the operations of an existing program (most common)</>,
      1: (
        <>
          To upgrade the infrastructure, systems, staff, or other resources or
          capacities of an existing program
        </>
      ),
    },
  },
  20009: {
    questionText: (
      <>
        Is this contribution essential to the program’s existence, and at what
        level?
      </>
    ),
    options: {
      0: (
        <>
          Foundational funding (total funding, seed funding, or the program
          wouldn't exist without this funding).
        </>
      ),
      1: <>It's a regular (but important!) contribution.</>,
    },
  },
  20016: {
    questionText: (
      <>
        Is this upgrade intended to increase the number of people the program
        can serve?
      </>
    ),
    options: {
      0: <>Yes</>,
      1: <>No</>,
    },
  },
};

export const firstInvestmentQuestionId = 20008;
export const investmentQuestions: {
  [id: number]: InvestmentQuestion | undefined;
} = {
  20008: {
    questionId: 20008,
    questionText: 'What is the purpose of this contribution to the program?',
    options: [
      {
        optionText:
          'To support the operations of an existing program (most common)',
        nextQuestionId: 20009,
      },
      {
        optionText:
          'To upgrade the infrastructure, systems, staff, or other resources or capacities of an existing program',
        nextQuestionId: 20016,
      },
    ],
  },
  20009: {
    questionId: 20009,
    questionText:
      'Is this contribution essential to the program’s existence, and at what level?',
    options: [
      {
        optionText:
          'Foundational funding (total funding, seed funding, or the program wouldn\'t exist without this funding).',
        nextQuestionId: undefined,
      },
      {
        optionText: 'It\'s a regular (but important!) contribution.',
        nextQuestionId: undefined,
      },
    ],
  },
  20016: {
    questionId: 20016,
    questionText:
      'Is this upgrade intended to increase the number of people the program can serve?',
    options: [
      {
        optionText: 'Yes',
        nextQuestionId: 20009,
      },
      {
        optionText: 'No',
        nextQuestionId: 20009,
      },
    ],
  },
};

export const getNextInvestmentQuestion = (
  question: InvestmentQuestion | undefined,
  answer: InvestmentAnswer | undefined,
): InvestmentQuestion | undefined => {
  if (!question) return undefined;
  if (!answer) return question;
  const nextQuestionId = question.options[answer.optionIndex].nextQuestionId;
  if (!nextQuestionId) return undefined;
  return investmentQuestions[nextQuestionId];
};
